﻿import { AddressPageController } from "./AddressPageController";
import { AppServices } from "./AppServices";
import { CouponController } from "./CouponController";
import { OrderReviewPageController } from "./OrderReviewPageController";
import { ProductRepository } from "./ProductRepository";
import { ShippingPageController } from "./ShippingPageController";
import { ShippingPickupPointSelector } from "./ShippingPickupPointSelector";
import { QtyBehavior, ShoppingCart } from "./ShoppingCart";
import { ToastType, Toaster } from "./Toaster";

export class BUApplication {
   private appServices_ = new AppServices();
   private shoppingCart_ = new ShoppingCart();
   private shippingPickupPointSelector_ = new ShippingPickupPointSelector();
   private productRepo_ = new ProductRepository();
   private shippingPage_;
   private addressPage_;
   private orderReviewPage_;
   private couponController_;

   constructor() {
      this.shippingPage_ = new ShippingPageController(this.appServices_);
      this.addressPage_ = new AddressPageController(this.appServices_);
      this.orderReviewPage_ = new OrderReviewPageController(this.appServices_);
      this.couponController_ = new CouponController(this.appServices_);
   }

   public get toaster(): Toaster {
      return this.appServices_.toastService;
   }

   public get shoppingCart(): ShoppingCart {
      return this.shoppingCart_;
   }

   public get productRepository(): ProductRepository {
      return this.productRepo_;
   }
   public addProductToCart(productId: number, inc: boolean, verify: boolean): boolean {
      if (verify) {
          const prod = this.productRepo_.checkProduct(productId);
          if (!prod) return false;
      }
      if (!inc) {
         const cartProd = this.shoppingCart.get(productId);
         if (cartProd)
            return true;
      }
      this.shoppingCart.add(productId, 1, QtyBehavior.Add);
      if (this.shoppingCart.get(productId)) return true;
      return false;
   }

   public selectShippingPickupPoint(resultElId: string, shippingMethodId: number, carrierCode: string, selectedAddress?: string): void {
      this.shippingPickupPointSelector_.select(resultElId, shippingMethodId, carrierCode, selectedAddress,
         (resultElId: string, shippingMethodId: number, json: string) => {
            this.shippingPage.onSelectedCarrierPickup(resultElId, shippingMethodId, json);
      });
   }

   public copyToClipboard(text: string): void {
      navigator.clipboard.writeText(text).then(function () {
         alert("Copied to clipboard!");
      }).catch(function (error) {
         alert(error);
      });
   }

   public showMessageModal(message: string): void {
      this.appServices_.modalService.showMessageModal(message);
   }

   public get shippingPage(): ShippingPageController {
      return this.shippingPage_;
   }
   public get addressPage(): AddressPageController {
      return this.addressPage_;
   }
   public get orderReviewPage(): OrderReviewPageController {
      return this.orderReviewPage_;
   }
   public get couponController(): CouponController {
      return this.couponController_;
   }

   public onPageLoad(): void {
      console.log('buApp:onPageLoad');
      this.addressPage_.onLoad();
      this.couponController_.onLoad();
   }
}